/** Класс открытия лайтбоксов */

/** Класс активности лайтбокса */
const CLASS_CURRENT: string = 'current';
const CLASS_HIDE_BUTTONS: string = 'hide-buttons';
const CLASS_DISABLED: string = 'disabled';
const CLASS_MOVE: string = 'move';
const ANIMATE_TIME: number = 500;

class ShowFadeLightbox
{
	/** Список лайтбоксов */
	private elementCollection: HTMLCollection | HTMLLIElement[];
	/** Конейнер который содержит элементы управления листалкой */
	private controls: HTMLElement;
	/** Контейнер для списка лайтбоксов, который двигается */
	private container: HTMLUListElement;
	/** Индекс активного элемента */
	private currentIndex: number;
	/** Кнопка назад */
	private prev: HTMLButtonElement;
	/** Кнопка вперёд */
	private next: HTMLButtonElement;
	/** Активна ли анимация */
	private isActive: boolean;
	/** Элемент main */
	private main: HTMLElement;
	
	constructor( elementCollection: HTMLCollection | HTMLLIElement[], controls: HTMLElement )
	{
		this.elementCollection = elementCollection;
		this.controls = controls;

		this.container = this.elementCollection[0].parentNode as HTMLUListElement;
		this.isActive = false;

		/** Для ios дикий костыль, так как он шапку и футер отображает поверх лайтбокса */
		this.main = document.querySelector( 'body>main' ) as HTMLElement;
		
		if ( controls )
		{
			this.next = controls.querySelector( 'button.next' ) as HTMLButtonElement;
			this.prev = controls.querySelector( 'button.prev' ) as HTMLButtonElement;

			if ( this.elementCollection.length > 1 )
			{
				this.prev.addEventListener( 'click', () => this.slidePrev() );
				this.next.addEventListener( 'click', () => this.slideNext() );
			}
			else
			{
				controls.classList.add( CLASS_HIDE_BUTTONS );
			}
		}
		
		window.addEventListener( 'resize', () => this.goToSlide() );
	}

	/** открытие лайтбокса */
	public open( index: number ): void
	{
		this.currentIndex = index;
		this.elementCollection[this.currentIndex].classList.add( CLASS_CURRENT );
		this.container.classList.add( CLASS_CURRENT );
		this.main.classList.add( CLASS_CURRENT );
		
		this.goToSlide();
		this.controls.style.visibility = 'visible'; // временно, потом вешать класс

		// Событие для пересчёта высоты экрана и отображения в нём влезших элементов
		this.elementCollection[this.currentIndex].dispatchEvent(
			new CustomEvent(
				'ShowLightbox:open',
				{
					detail: true,
					bubbles: true
				}
			)
		);
	}

	/** закрытие лайтбокса */
	public close(): void
	{
		this.elementCollection[this.currentIndex].classList.remove( CLASS_CURRENT );
		this.container.classList.remove( CLASS_CURRENT );
		this.main.classList.remove( CLASS_CURRENT );
		
		this.controls.style.visibility = ''; // временно, потом вешать класс
		this.next.classList.remove( CLASS_DISABLED );
		this.prev.classList.remove( CLASS_DISABLED );
		
		// Событие для пересчёта высоты экрана и отображения в нём влезших элементов
		this.elementCollection[this.currentIndex].dispatchEvent(
			new CustomEvent(
				'ShowLightbox:close',
				{
					detail: true,
					bubbles: true
				}
			)
		);
	}

	/** переключить слайд */
	private goToSlide(): void
	{
		if ( !this.container.classList.contains( CLASS_CURRENT ) )
		{
			return;
		}
		
		if ( this.currentIndex >= this.elementCollection.length - 1 )
		{
			this.next.classList.add( CLASS_DISABLED );
		}
		if ( this.currentIndex <= 0 )
		{
			this.prev.classList.add( CLASS_DISABLED );
		}
		
		const asideId = this.elementCollection[this.currentIndex].querySelector('aside').id;

		window.location.hash = asideId; // изменение хеша при смене лайтбокса

		// custom для того, чтобы пропадали кнопки при перелистывании и потом появлялись
		// if ( this.controls.contains( event.target as HTMLElement ) )
		// {
		// 	this.container.parentElement.classList.add( CLASS_HIDE_BUTTONS );
		// 	setTimeout( () => this.container.parentElement.classList.remove( CLASS_HIDE_BUTTONS ), ANIMATE_TIME );
		// }
	}

	/** следующий слайд */
	private slideNext(): void
	{
		if ( !this.isActive )
		{
			if ( this.currentIndex < this.elementCollection.length - 1 )
			{
				this.elementCollection[this.currentIndex].classList.remove( CLASS_CURRENT );
				this.currentIndex++;
				this.goToSlide();
				this.isActive = true;
				setTimeout( () => this.isActive = false, ANIMATE_TIME );
				// this.container.classList.add( CLASS_MOVE );
				// setTimeout( () => this.container.classList.remove( CLASS_MOVE ), ANIMATE_TIME );
				
				/*if ( this.currentIndex >= this.elementCollection.length - 1 )
				{
					this.elementCollection[this.currentIndex] = this.elementCollection[this.elementCollection.length - 1];
					this.currentIndex = this.elementCollection.length - 1;
					this.next.classList.add( CLASS_DISABLED );
				}
				else
				{
					this.next.classList.remove( CLASS_DISABLED );
				}*/

				if ( this.prev.classList.contains( CLASS_DISABLED ) )
				{
					this.prev.classList.remove( CLASS_DISABLED );
				}
				
				this.elementCollection[this.currentIndex].classList.add( CLASS_CURRENT );
			}
		}
	}

	/** предыдущий слайд */
	private slidePrev(): void
	{
		if ( !this.isActive )
		{
			if ( this.currentIndex > 0 )
			{
				this.elementCollection[this.currentIndex].classList.remove( CLASS_CURRENT );
				this.currentIndex--;
				this.goToSlide();
				this.isActive = true;
				setTimeout( () => this.isActive = false, ANIMATE_TIME );
				// this.container.classList.add( CLASS_MOVE );
				// setTimeout( () => this.container.classList.remove( CLASS_MOVE ), ANIMATE_TIME );
				
				/*if ( this.currentIndex <= 0 )
				{
					this.elementCollection[this.currentIndex] = this.elementCollection[0];
					this.currentIndex = 0;
					this.prev.classList.add( CLASS_DISABLED );
				}
				else
				{
					this.prev.classList.remove( CLASS_DISABLED );
				}*/

				if ( this.next.classList.contains( CLASS_DISABLED ) )
				{
					this.next.classList.remove( CLASS_DISABLED );
				}
				
				this.elementCollection[this.currentIndex].classList.add( CLASS_CURRENT );
			}
		}
	}
}

export {
	ShowFadeLightbox as default,
}
